module.exports = __webpack_public_path__ + "static/media/chocolates.2e9e071a.webp";